export default "__VITE_ASSET__Dm$2InG6__"